import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { getUserRole } from "selectors/user";
import { useSelector } from "react-redux";
import ActivityTab from "./lib/ActivityTab";
import DataStatuses from "const/DataStatuses";
import DocumentTab from "./lib/DocumentTab";
import FormContext from "contexts/FormContext";
import React, { useContext, useMemo, useState } from "react";
import Tabs, { Tab } from "nlib/ui/Tabs";
import UserRoles from "const/UserRoles";
import useEnvVars from "hooks/useEnvVars";

const DOCUMENT_FROZEN_STATUSES = [
  DataStatuses.TO_REPORT,
  DataStatuses.EXCLUDED,
  DataStatuses.EXPORTED
];

const MODES = {
  DEFAULT: "default",
  LINE_ITEMS: "lineItems",
  ACTIVITY: "comments"
};

const OldEditForm = ({ disabled, documentData }) => {
  const [{ editItem }] = useEnvVars();

  const [, tabToOpen] = editItem ? editItem.split(".") : [];

  const { uiTexts } = useSelector(getTextsData);

  const userRole = useSelector(getUserRole);

  const [currentTab, setCurrentTab] = useState(MODES[tabToOpen] ? tabToOpen : MODES.DEFAULT);

  const { values: { lineItems = [] } } = useContext(FormContext);

  const businessUser = UserRoles.checkIsBusiness(userRole);

  const documentFrozen = DOCUMENT_FROZEN_STATUSES.includes(documentData.status);

  const lineItemsValid = useMemo(() => {
    return lineItems.every(({ description, amountTotal = null, category = {} }) => {
      return description && amountTotal !== null && (businessUser || category.code);
    });
  }, [businessUser, lineItems]);

  return (
    <>
      <Tabs disabled={disabled} className={Css.tabs} current={currentTab} onChange={setCurrentTab}>
        <Tab className={Css.tab} value={MODES.DEFAULT}>
          <Icons.NotePencil /><span>{uiTexts.document}</span>
        </Tab>
        <Tab className={Css.tab} value={MODES.ACTIVITY}>
          <Icons.Lightning /><span>{uiTexts.activity}</span>
        </Tab>
      </Tabs>
      {({
        [MODES.DEFAULT]: (
          <DocumentTab
            documentData={documentData}
            lineItemsValid={lineItemsValid}
            documentFrozen={documentFrozen} />
        ),
        [MODES.ACTIVITY]: <ActivityTab disabled={disabled} documentData={documentData} />
      }[currentTab])}
    </>
  );
};

export default React.memo(OldEditForm);
